<script setup lang="ts">
import JobPostForm from "~/components/JobPostForm.vue";
import { getSeoObject } from "~/helpers/seo";
import { useRoute } from "vue-router";

const $route = useRoute();

const { data: jobPost } = useCustomFetch(
  `/api/strapi/new-job-posts?filters[slug][$eq]=${$route.params.slug}`,
);

const data = computed(() => jobPost.value?.[0].attributes);

// useSeoMeta(getSeoObject(data.value?.seo));
</script>

<template>
  <section v-if="data" id="maincontentblock" class="job-post-maincontentblock">
    <SeoMeta v-if="data?.seo" v-bind="data?.seo" />
    <div class="container">
      <div class="job-post-header">
        <h2>{{ data?.title }}</h2>
        <h3>{{ data?.location }}</h3>
      </div>
      <div class="wrapperblock">
        <div class="container">
          <div class="effects-job-post">
            <div class="blureffect left"></div>
            <div class="blureffect left"></div>
            <div class="blureffect left"></div>
          </div>

          <div class="row">
            <div class="col-md-6 gap-3">
              <div
                class="job-post-left"
                v-html="$mdRenderer.renderInline(data?.description)"></div>
              <div class="mt-4"> 
                <p style="font-weight: 700;">{{data?.listOfAttributes.titleResponsabilities}}</p>
                <div v-for="responsability in data?.listOfAttributes.responsabilities">
                  <p v-if="responsability.title !=''" style="font-weight: 600;">{{ responsability.title }}</p>
                  <ul>
                  <li v-for="list in responsability.list"> {{ list }}</li>
                </ul>
                </div>
             
              </div>
              <div> 
                <p style="font-weight: 700;">{{data?.listOfAttributes.titleRequirements}}</p>
                <ul>
                  <li v-for="requirement in data?.listOfAttributes.requirements"> {{ requirement }}</li>
                </ul>
              </div>
              <div>
                <p style="font-weight: 700;">{{ data?.listOfAttributes.joinTitle }}</p>
                <ul>
                  <li v-for="join in data?.listOfAttributes.join">
                    <p style="font-weight: 600;">{{ join.title }}</p>
                    <p style="line-height: inherit; font-size: inherit; font-weight: inherit;">{{ join.description }}</p>
                  </li>
                  </ul>
                <p style="font-weight: 700;">{{ data?.listOfAttributes.endTitle }}</p>
              </div>
            </div>
           
            <div class="col-md-6">
              <JobPostForm :title="data?.title" :location="data?.location" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
